export const ANDROID_TABLET_MENU_OFFSET = 120; // px offset to push the vertical menu down on Android tablets
export const ANDROID_TABLET_MENU_WIDTH = 76;   // px width of the menu column in landscape
export const ANDROID_TABLET_SCROLL_REDUCTION = 100; // px to trim from bottom to force scrollable areas

export function isAndroidTabletDevice(viewport: { isAndroidTablet?: boolean }): boolean {
  return !!viewport.isAndroidTablet;
}
